import React, { useState } from 'react';
import Header from '../../component/layout/Header';
import Footer from '../../component/layout/Footer';
import Page from '../../component/utility/Page';
import DataTable from 'react-data-table-component';
import { custTableStyles } from '../../style/color';
import axios from 'axios';

import { Row, Col, Card, CardBody, Button } from 'reactstrap';
import {FaEye, FaEdit, FaPlusCircle, FaClipboardList} from 'react-icons/fa';
import {MdDeleteForever } from 'react-icons/md';

import ViewFarmer from '../../component/utility/master/ViewFarmer';
import AddFarmer from '../../component/utility/master/AddFarmer';
import EditFarmer from '../../component/utility/master/EditFarmer';
import DeleteFarmer from '../../component/utility/master/DeleteFarmer';


const Farmer = () => {
    const [mode, setMode] = useState(1);
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState('');
    const [f_data, setF_Data] = useState('');
    const [displayConfirmationModal, setDisplayConfirmationModal] = useState(false); 
    const [deleteMsg, setDeleteMsg] = useState(null);

    function toggle(){
        setDisplayConfirmationModal(!displayConfirmationModal);
    }

    const farmer_list = () => {
        let postData = [{"org_id": sessionStorage.getItem('org_id'), "user_id": sessionStorage.getItem('user_id'), "dist_id": 0, "block_id": 0, "vill_id":0}];
        axios({
            method: 'post',
            url: 'https://api2.boxfarming.in/wsapi/v2/index.php/Farmer/box_farmer_list',
            data: postData,
            headers: { 'Content-Type': 'application/JSON', }
        })
            .then(function (response) {
                let list = response.data.map((row, index) => {
                    
                    return(
                        {
                            ids: index + 1 ,
                            name: row.f_name +" ("+ row.f_reg_no +")",
                            mobile: row.mobile_no,
                            spouse_name: row.f_spouse_name,
                            location: row.state_name +"/"+ row.district_name +"/"+ row.block_name +"/"+ row.village_name,
                            action: <div>
                                        <FaEye className='me-3 cursor' color="#FFC000" size={20} onClick={()=>view_handler(row)} />
                                        <FaEdit className='me-3 cursor' color="#006600" size={20} onClick={()=>edit_handler(row)} />
                                        <MdDeleteForever className='cursor' color="#f70000" size={20} onClick={()=>delete_handler(row.f_name, row.farmer_code)}/>
                                    </div>
                        }
                    )
                });

                setTableData(list);
            })
            .catch(error => {
                setLoading(false);
                //let notify = notification({ message: "User list not Found! Try Again", type: 'error' });
                //notify();
            });
    }

    const view_handler = (data) => {
        setF_Data(data);
        setMode(3);
    }
    
    const edit_handler = (data) => {
        setF_Data(data);
        setMode(4);
        // console.log(data);
    }

    function delete_handler(farmerName, farmerCode){
        setDeleteMsg(`Confirm Delete ${farmerName} [code:${farmerCode}] ?`);
        toggle();
    }

    const back_handler = () => {
        setMode(1);
    }


    return (
        <>
            <Header />
            <Page title='Farmer' breadcrumbs='Home / Farmer'>
                <Row className='p-3'>
                    { mode === 1 &&
                    <Col xs={12}>
                        <Card className='mb-3' color="primary" outline>
                            <CardBody>
                                <Row>
                                    <Col md={2}>
                                        <Button className='text-white' color='primary' size="sm" block onClick={farmer_list}> 
                                            <FaClipboardList className='me-1' size={20} /> 
                                            Get Farmer List
                                        </Button>
                                    </Col>
                                    <Col md={2}>
                                        <Button className='text-white' color='primary' size="sm" block onClick={() => setMode(2)}> 
                                            <FaPlusCircle className='me-1' size={20} /> 
                                            Add New Farmer 
                                        </Button>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card className='' color="primary" outline>
                            <CardBody>
                                <DataTable
                                    title=""
                                    customStyles={custTableStyles}
                                    columns={[
                                        {
                                        name: 'Id',
                                        selector: row=>row.ids,
                                        sortable: true,
                                        width: '80px'
                                        },
                                        {
                                        name: 'Name',
                                        selector: row=>row.name,
                                        sortable: false,
                                        width: "20%",
                                        wrap: true
                                        },
                                        {
                                        name: 'Mobile Number',
                                        selector: row=>row.mobile,
                                        sortable: false,
                                        },
                                        {
                                        name: 'Spouse Name',
                                        selector: row=>row.spouse_name,
                                        sortable: false,
                                        wrap: true
                                        },
                                        {
                                        name: 'Location',
                                        selector: row=>row.location,
                                        sortable: false,
                                        width: "25%",
                                        wrap: true
                                        },
                                        {
                                        name: 'Action',
                                        selector: row=>row.action,
                                        sortable: false,
                                        },
                                    ]}
                                    data={tableData}
                                    highlightOnHover
                                    progressPending={loading}
                                    pagination
                                />
                            </CardBody>
                        </Card>
                    </Col>
                    }

                    { mode === 2 &&
                        <Col xs={12}>
                            <AddFarmer back={()=>back_handler()}/>
                        </Col>
                    }
                    { mode === 3 &&
                        <Col xs={12}>
                            <ViewFarmer data={f_data} back={()=>back_handler()}/>
                        </Col>
                    }
                    
                    { mode === 4 &&
                        <Col xs={12}>
                            <EditFarmer data={f_data} back={()=>back_handler()}/>
                        </Col>
                    }

                </Row>

            </Page>
            <Footer />
            <DeleteFarmer showConfirmationModal={displayConfirmationModal} toggle={toggle} message={deleteMsg}/>
        </>
    )

}

export default Farmer;